export default "__VITE_ASSET__2e21b0b3__"